export default "__VITE_ASSET__cd0d84e1__"